var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoValide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640.000000 640.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,640.000000) scale(0.100000,-0.100000)",
    fill: "#EFF5FA",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5086 4979 c-64 -15 -176 -73 -251 -130 -38 -28 -572 -553 -1186 -1166 l-1116 -1115 -404 404 c-222 222 -435 433 -474 468 -95 86 -190 146 -288 182 -73 27 -91 29 -167 26 -104 -5 -169 -35 -240 -109 -164 -171 -202 -489 -80 -663 16 -23 314 -325 662 -671 776 -773 821 -810 993 -810 71 0 88 4 145 33 36 18 103 64 150 102 47 38 677 662 1401 1387 1509 1511 1363 1344 1363 1553 1 130 -10 181 -62 284 -43 87 -119 168 -190 203 -43 21 -72 27 -136 29 -45 2 -99 -1 -120 -7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoValide);
export default __webpack_public_path__ + "static/media/LogoValide.5a9e8c5f1e324504e961b2f03d9323b1.svg";
export { ForwardRef as ReactComponent };